import {ContratMenuConvive__ContrainteAlimDTO} from "../../dtos/contratmenuconvive__contrainte-alim-dto";
import {ContratMenuConviveDTO} from "../../dtos/contratmenuconvive-dto";

export default class DuplicationMenuDataModel {
  sourceCmcCaList: ContratMenuConvive__ContrainteAlimDTO[] = [];
  targetCmcCaList: ContratMenuConvive__ContrainteAlimDTO[] = [];
  sourceCmcList: ContratMenuConviveDTO[] = [];
  targetCmcList: ContratMenuConviveDTO[] = [];
}
